import makeStyles from "@mui/styles/makeStyles";

import { ListItemRowProps } from "./ListItemRow.types";

export const useStyles = makeStyles((theme) => ({
  root: (props: ListItemRowProps) => ({
    "& > .MuiGrid-item": {
      padding: 0,
      overflow: "auto",
    },
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    background: props.isHeader ? theme.palette.grey[100] : "none",
    overflow: "auto",
  }),
  circle: {
    color: theme.palette.grey[500],
    "&:hover": {
      color: theme.palette.primary.main,
      borderRadius: "50%",
      background: "#F4F6FB",
      cursor: "pointer",
    },
  },
  emptyContainer: {
    position: "absolute",
    width: 40,
    height: 40,
    zIndex: 9,
  },
  disabled: {
    "&:hover": {
      cursor: "not-allowed",
    },
  },
  checkbox: {
    alignItems: "flex-start",
    marginTop: -8,
  },
}));
